// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-close-solid';

export const Component = () => (
  <path d='M23.563 4.97H10.776l-.767-2.3C9.913 2.24 9.627 2 9.1 2H.958a.946.946 0 0 0-.67.288c-.192.24-.288.478-.288.718v19.636c0 .24.096.48.287.67a.946.946 0 0 0 .67.288h22.606a.94.94 0 0 0 .67-.288.946.946 0 0 0 .288-.67V5.927a.946.946 0 0 0-.287-.67.946.946 0 0 0-.67-.287Zm-10.632 9.29 2.635 2.635a.434.434 0 0 1 .143.335c0 .336-.191.48-.526.48a.434.434 0 0 1-.335-.144l-2.586-2.586-2.586 2.586a.434.434 0 0 1-.335.143c-.336 0-.527-.143-.527-.479 0-.143.048-.239.144-.335l2.634-2.634-2.634-2.586a.434.434 0 0 1-.144-.335c0-.335.144-.48.479-.48a.54.54 0 0 1 .383.145l2.586 2.586 2.586-2.586a.434.434 0 0 1 .335-.144c.335 0 .526.144.526.479 0 .047-.047.144-.143.335l-2.635 2.586Z' />
);

export const viewBox = '0 0 25 25';
